import { calculateBMI } from './components/Helpers/Conversion';
// account should be the only one using this
// all items will be cleared when account/session expires
function setSessionStorageItemWithExpiration(key, value, timeoutInMinutes) {
  const now = new Date();

  const expireTime = new Date(now.getTime() + timeoutInMinutes * 60000);

  const storeItem = {
    value: value,
    expiration: expireTime
  };

  sessionStorage.setItem(key, JSON.stringify(storeItem));
}

function setSessionStorageItem(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}

function getSessionStorageItem(key) {
  const item = sessionStorage.getItem(key);

  if (!item) {
    return null;
  }

  const itemJson = JSON.parse(item);

  if (itemJson.expiration) {
    const currentTime = new Date();
    const expireTime = new Date(itemJson.expiration);

    if (currentTime > expireTime) {
      fetch("api/ConsumerApplication/NewSession");

      if (shouldRedirect()) {
        sessionStorage.clear();

        // redirect to home screen after expiration
        window.location = '/';

        return null;
      }
    } else {
      // if expiring item, extend timeline
      setSessionStorageItemWithExpiration(key, itemJson.value, 60);
    }
  }

  return itemJson.value || itemJson;
}

function removeSessionStorageItem(key) {
  sessionStorage.removeItem(key);
}

function storeConsumerApplicationId(res) {
  const consumerApplicationId = res.headers.get('X-Consumer-Application-ID');
  if (consumerApplicationId) {
    const sessionData = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_ACCOUNT_KEY));
    sessionData.value.consumerApplicationId = consumerApplicationId;
    setSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY, sessionData);
  }
  return res.json();
}

function deleteConsumerApplicationId(res) {
  if (getSessionStorageItem(SESSION_STORAGE_SSO_ACCESS_TOKEN_KEY)) {
    const sessionData = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_ACCOUNT_KEY));
    delete sessionData.value.consumerApplicationId;
    setSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY, sessionData);
  }
  return res.json();
}

function shouldRedirect() {
  let currentURL = window.location.href.split('/');
  const pagesToPreventRedirectOnExpire = ['status', 'landing', 'retrieveprogress'];

  // remove any query strings
  currentURL = currentURL.map((url) => url.split("?")[0]);

  return !currentURL.some(urlSegment => pagesToPreventRedirectOnExpire.includes(urlSegment.toLowerCase()));
}

// define the standard basic info data
const basicInfo = {
  firstName: null,
  lastName: null,
  phone: null,
  gender: null,
  birthdate: null,
  tobacco: null,
  state: null,
  height: null,
  weight: null,
  email: null,
  usResident: null,
  replacePolicy: null,
  preQuoteHealthClass: null,
  preQuoteAbbreviatedQualified: null,
  bmi: null,
  coverageLength: null,
  faceAmount: null,
  healthClass: null,
  income: null
};

// Grab Basic Info from localstorage, if not there return a new one
function getBasicInfo() {
  const basicInfoFromStorage = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_BASIC_INFO_KEY)) || basicInfo;

  if (!basicInfoFromStorage.birthdate && getSessionStorageItem(SESSION_STORAGE_CLIENTINFO_KEY)) {
    const clientInfo = getSessionStorageItem(SESSION_STORAGE_CLIENTINFO_KEY);
    basicInfoFromStorage.phone = clientInfo.phone;
    basicInfoFromStorage.gender = clientInfo.gender;
    basicInfoFromStorage.birthdate = clientInfo.dateOfBirth;
    basicInfoFromStorage.tobacco = String(clientInfo.tobacco);
    basicInfoFromStorage.state = clientInfo.state;
    basicInfoFromStorage.height = clientInfo.heightString;
    basicInfoFromStorage.weight = clientInfo.weightString;
    basicInfoFromStorage.email = clientInfo.email;
    basicInfoFromStorage.usResident = clientInfo.usResident;
    basicInfoFromStorage.replacePolicy = clientInfo.replacePolicy;
    basicInfoFromStorage.bmi = calculateBMI(clientInfo.totalInches, clientInfo.weight) || undefined;
    basicInfoFromStorage.coverageLength = clientInfo.termLength;
    basicInfoFromStorage.faceAmount = clientInfo.faceAmount;
    basicInfoFromStorage.healthClass = clientInfo.healthClass;
    basicInfoFromStorage.firstName = clientInfo.firstName;
    basicInfoFromStorage.lastName = clientInfo.lastName;
    basicInfoFromStorage.income = clientInfo.income;
    basicInfoFromStorage.termLength = clientInfo.termLength;
  }

  return basicInfoFromStorage;
}

// Save Basic Info to local storage
function setBasicInfo(basicInfo) {
  sessionStorage.setItem(SESSION_STORAGE_BASIC_INFO_KEY, JSON.stringify(basicInfo));
}

export {
  setSessionStorageItemWithExpiration,
  setSessionStorageItem,
  getSessionStorageItem,
  removeSessionStorageItem,
  getBasicInfo,
  setBasicInfo,
  storeConsumerApplicationId,
  deleteConsumerApplicationId,
};

// keys
export const SESSION_STORAGE_ACCOUNT_KEY = 'ACCOUNT_OBJECT';
export const SESSION_STORAGE_ACTIVE_PURL = 'ACTIVE_PURL';
export const SESSION_STORAGE_COVERAGE_AMOUNT_KEY = 'COVERAGE_AMOUNT';
export const SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY = 'TERM_COVERAGE_AMOUNT';
export const SESSION_STORAGE_TERM_LENGTH_KEY = 'TERM_LENGTH';
export const SESSION_STORAGE_COVR_FULLUW_KEY = 'COVR_FULLUW';
export const SESSION_STORAGE_DISABILITY_KEY = 'DISABILITY_QUOTE';
export const SESSION_STORAGE_ESIGN_AUTH_KEY = 'ESIGN_AUTH';
export const SESSION_STORAGE_HEALTH_CLASS_KEY = 'HEALTH_CLASS';
export const SESSION_STORAGE_NEEDS_ANALYSIS_KEY = 'INSURANCE_NEEDS_ANALYSIS';
export const SESSION_STORAGE_TERM_ALTERNATIVES_KEY = 'TERM_ALTERNATIVES';
export const SESSION_STORAGE_TERM_PRE_RUN_QUOTE_KEY = 'TERM_PRE_RUN_QUOTE';
export const SESSION_STORAGE_TERM_STRUCTURE = 'TERM_STRUCTURE';
export const SESSION_STORAGE_EMAIL_CAPTURE = 'EMAIL_CAPTURE';
export const SESSION_STORAGE_SAVED_QUOTE_DATA = 'SAVED_QUOTE_DATA';
export const SESSION_STORAGE_AMERICO_DECLINED_REASONS_KEY = 'AMERICO_DECLINED_REASONS';
export const SESSION_STORAGE_BASIC_INFO_KEY = 'BASIC_INFO';
export const SESSION_STORAGE_CLIENTINFO_KEY = 'CLIENTINFO_OBJECT';
export const SESSION_STORAGE_AFLAC_QUOTE = 'AFLAC_QUOTE';
export const SESSION_STORAGE_APPOINTMENT_KEY = 'SESSION_STORAGE_APPOINTMENT_KEY';
export const SESSION_STORAGE_POLICY_REVIEW = 'POLICY_REVIEW';
export const SESSION_STORAGE_FULLY_DIGITAL_OBJECT_KEY = "SESSION_STORAGE_FULLY_DIGITAL_OBJECT_KEY";
export const SESSION_STORAGE_AMERICO_OBJECT_KEY = "SESSION_STORAGE_AMERICO_OBJECT_KEY";
export const SESSION_STORAGE_AMERICO_KEY = "AMERICO_QUOTE";
export const SESSION_STORAGE_TERM_SORT_FILTER_KEY = "TERM_SORT_FILTER_KEY";
export const SESSION_STORAGE_CUSTOMIZED_TERM_KEY = "CUSTOMIZED_TERM_KEY";
export const SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY = "CUSTOMIZED_HEALTH_KEY";
export const SESSION_STORAGE_CUSTOMIZED_TEASER_KEY = "CUSTOMIZED_TEASER_KEY";
export const SESSION_STORAGE_FINAL_EXPENSE_TERM_KEY = "FINAL_EXPENSE_TERM_KEY";
export const SESSION_STORAGE_FINAL_EXPENSE_HEALTH_KEY = "FINAL_EXPENSE_HEALTH_KEY";
export const SESSION_STORAGE_FINAL_EXPENSE_SORT_FILTER_KEY = "FINAL_EXPENSE_SORT_FILTER_KEY";
export const SESSION_STORAGE_WHOLE_LIFE_TERM_KEY = "WHOLE_LIFE_TERM_KEY";
export const SESSION_STORAGE_WHOLE_LIFE_HEALTH_KEY = "WHOLE_LIFE_HEALTH_KEY";
export const SESSION_STORAGE_UNIVERSAL_LIFE_TERM_KEY = "UNIVERSAL_LIFE_TERM_KEY";
export const SESSION_STORAGE_UNIVERSAL_LIFE_HEALTH_KEY = "UNIVERSAL_LIFE_HEALTH_KEY";
export const SESSION_STORAGE_BUSINESS_SOLUTIONS_KEY = "BUSINESS_SOLUTIONS_KEY";
export const SESSION_STORAGE_UTM_DATA = "UTM_DATA";
export const SESSION_STORAGE_ANALYSIS_KEY = "ANALYSIS_KEY";
export const SESSION_STORAGE_AMERICO_PARTNER_KEY = "AMERICO_PARTNER_QUOTE";
export const SESSION_STORAGE_SSO_ACCESS_TOKEN_KEY = "SSO_ACCESS_TOKEN";
